module.exports = __webpack_public_path__ + "img/th.5a4f1a9a.png";